import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { styled } from '@material-ui/core/styles';
import LinkIcon from '@material-ui/icons/Link';
import NotificationsActiveOutlined from '@material-ui/icons/NotificationsActiveOutlined';

export const StyledCard = styled(Card)(({ theme }) => ({
  background: theme.palette.grey[100],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none'
}));

export const StyledContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  '&:last-child': {
    paddingBottom: theme.spacing(2)
  }
}));

export const TitleRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1)
}));

export const TitleIcon = styled(NotificationsActiveOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginRight: theme.spacing(1)
}));

export const ChecksContainer = styled(Grid)({
  alignItems: 'center'
});

export const DividerStyled = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0)
}));

export const LinkRow = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex'
}));

export const LinkRowIcon = styled(LinkIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(1)
}));

export const TruncatedLink = styled(Link)({
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
